<script setup lang="ts">
const { t } = useI18n();
const isOpen = ref(false);

const links = computed(() => [
  {
    label: t('HOME'),
    icon: 'i-heroicons-home',
    to: '/',
  },
  {
    label: t('USERS'),
    icon: 'i-heroicons-user-group',
    to: '/users',
  },
  {
    label: t('FAQS'),
    icon: 'i-heroicons-question-mark-circle',
    to: '/faqs',
  },
  {
    label: t('BLOG_CATEGORIES'),
    icon: 'i-heroicons-building-library',
    to: '/blog/categories',
  },
  {
    label: t('BLOG_POSTS'),
    icon: 'i-heroicons-document-text',
    to: '/blog/posts',
  },
  {
    label: t('PRODUCTS'),
    icon: 'i-heroicons-building-library',
    to: '/products',
  },
  {
    label: t('SUPPORT_SECTIONS'),
    icon: 'i-heroicons-document-text',
    to: '/support/sections',
  },
  {
    label: t('SUPPORT_ARTICLES'),
    icon: 'i-heroicons-document-text',
    to: '/support/articles',
  },
  {
    label: t('LEGAL'),
    icon: 'i-heroicons-document-text',
    to: '/legal',
  },
]);

const linksMobile = computed(() => links.value.map((l) => ({ ...l, click: toggleMnMb })));


function toggleMnMb() {
  isOpen.value = !isOpen.value;
}

</script>
""
<template>
  <div>
    <div>
      <nuxt-link to="/">
        <img src="https://assets.nuinalp.com/logo/logo-square.svg"
          alt="Nuinalp CMS logo" class="logo my-2 block">
      </nuxt-link>
      <UVerticalNavigation :links="links" class="mt-9" />
    </div>

    <portal to="#mobile_menu">
      <UButton :padded="false" color="gray" variant="link" icon="i-heroicons-bars-3-solid" @click="toggleMnMb" />
    </portal>

    <Teleport to="body">
      <USlideover v-model="isOpen" side="left">
        <div class="p-4 flex-1">
          <div class="flex justify-between justify-items-center">
            <nuxt-link to="/" @click="toggleMnMb">
              <img src="https://assets.nuinalp.com/logo/logo-square.svg"
                alt="Nuinalp CMS logo" class="logo my-2 block">
            </nuxt-link>

            <UButton color="gray" variant="ghost" icon="i-heroicons-x-mark-20-solid" class="self-center"
              @click="isOpen = false" />
          </div>
          <UVerticalNavigation :links="linksMobile" class="mt-9" />
        </div>
      </USlideover>
    </Teleport>
  </div>
</template>
<style lang="scss" scoped>
.logo {
  width: 140px;
}
</style>
